export { string } from './Localization';
